<app-content-items [contentItems]="col.Components" [colSize]="getColSize()" class="DTX_CONTENT_ITEMS" />
